import styled from 'styled-components'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'

export const List = styled.div`
  width: 100%;

  ul {
    background-color: #f1f1f1;
    color: #141414;
    display: list-item;
    font-family: ${fonts.inter};
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 2.1rem;
    list-style-type: none;
    padding-inline-start: 0;
    text-align: justify;

    li:nth-child(even) {
      background-color: ${colors.neutralColorHighPure};
    }

    li {
      padding: 0.55rem 0.8rem;
    }
  }
`
export const Title = styled.span`
  color: #656565;
  display: flex;
  font-family: ${fonts.inter};
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.8rem;
  text-transform: uppercase;
`
